import { Card, Typography } from 'antd';
import type { ReactNode } from 'react';
import { neutral, space, typography } from '@/design/tokens.js';

const { Text } = Typography;

export interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}

/**
 * The frame around every unauthenticated screen.
 *
 * One layout for sign-in, invitations, forgotten passwords and resets, so the
 * whole signed-out journey reads as one product rather than four pages that
 * happen to share a colour scheme.
 */
export function AuthLayout({ title, subtitle, children, footer, width = 400 }: AuthLayoutProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: space[4],
        background: 'var(--ant-color-bg-layout)',
      }}
    >
      <div style={{ width: '100%', maxWidth: width }}>
        <div style={{ textAlign: 'center', marginBottom: space[6] }}>
          <span
            aria-hidden
            style={{
              display: 'inline-grid',
              placeItems: 'center',
              width: 44,
              height: 44,
              borderRadius: 11,
              background:
                'linear-gradient(135deg, var(--ant-color-primary) 0%, var(--ant-color-primary-active) 100%)',
              color: neutral[0],
              fontWeight: typography.weight.bold,
              fontSize: typography.size.xl,
              marginBottom: space[3],
            }}
          >
            O
          </span>
          <h1
            style={{
              margin: 0,
              fontSize: typography.size.xl,
              fontWeight: typography.weight.semibold,
              letterSpacing: typography.letterSpacing.tighter,
            }}
          >
            {title}
          </h1>
          {subtitle ? <Text type="secondary">{subtitle}</Text> : null}
        </div>

        <Card variant="outlined">{children}</Card>

        {footer ? (
          <div
            style={{
              textAlign: 'center',
              marginTop: space[4],
              fontSize: typography.size.sm,
            }}
          >
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
